import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import LandingPage from "./pages/LandingPage";
import {pollImpact} from '../common/api/impactPoller';
import ImpactPage from "./pages/ImpactPage";

function App() {
  const merchantCode = 'BES_NZ_GOOD_GRAPE';
  const [fetchedImpact, setFetchedImpact] = useState();

  useEffect(() => {
    pollImpact(setFetchedImpact,merchantCode);
  }, []);

  return (
    <>

      <Switch>
        <Route
          exact
          path={`/impact`}
          key="app-good-grape-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        <Route
          path={`/`}
          key="app-good-grape-landing"
        >
          <LandingPage fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}

export default App;
